import { render, staticRenderFns } from "./CameraDetail.vue?vue&type=template&id=4e8fa5c2&scoped=true"
import script from "./CameraDetail.vue.js?vue&type=script&lang=js&external"
export * from "./CameraDetail.vue.js?vue&type=script&lang=js&external"
import style0 from "./CameraDetail.vue?vue&type=style&index=0&id=4e8fa5c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8fa5c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VImg,VTab,VTabItem,VTabs,VTabsItems})
